//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import { FocusTrap } from 'focus-trap-vue';
import {
  ref, computed, watch, defineComponent,
} from '@vue/composition-api';
import { FCCart, FCButton } from '@fc/angie-ui';
import { windowMatchMediaMixin } from '~/mixins/matchMedia';
import { useDrift } from '~/composables/useDrift';
import toggleScroll from '~/utils/toggleScroll';
import { useCartContext } from '~/composables/useCartContext';
import CalculateEstimatedTax from './CalculateEstimatedTax.vue';

Vue.component('FocusTrap', FocusTrap);
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 100,
});

export default defineComponent({
  name: 'CartDrawer',
  mixins: [windowMatchMediaMixin],
  components: {
    FCButton,
    CartDisplay: () => import('~/components/checkout/components/CartDisplay.vue'),
    CartDisplayShopify: () => import('~/components/checkout/components/shopify/CartDisplayShopify.vue'),
    ObjectionKillersCartDrawer: () => import('~/components/checkout/components/ObjectionKillersCartDrawer.vue'),
    FCCart,
    CalculateEstimatedTax,
  },

  setup() {
    const cartActive = ref(false);
    const getTabIndex = computed(() => (cartActive.value ? 0 : -1));
    const getJustifyContent = computed(() => (cartDrawerOpen.value ? 'fc-justify-end' : 'fc-justify-between'));

    const {
      $store, $router, $analytics,
    } = useNuxtApp();
    const {
      cartDrawerOpen, cart, isEquipInCart, isCartEmpty,
    } = useCartContext();

    const bundle = computed(() => $store.getters.bundle);
    const isShopifyOn = computed(() => $store.getters.isShopifyOn && !$store.getters.isGQOrder);
    const route = computed(() => $store.getters.currentRoute);

    const isInCheckout = computed(() => route?.value?.name?.includes('checkout') ?? false);

    const getCtaText = computed(() => (isCartEmpty.value ? 'Shop Now' : 'Checkout'));

    const isTest14 = computed(() => $store.getters.getExperimentById('0014_checkout_signals')?.variant === '1');

    const closeDrawer = () => { $store.commit('closeDrawer'); };

    const onConfirm = () => {
      closeDrawer();
      if (isCartEmpty.value) {
        $router.push({ path: '/shop/products/fightcamp' });
      } else {
        $router.push({ path: '/shop/checkout' });
      }
    };

    const { toggleDriftChat } = useDrift();
    watch(cartDrawerOpen, (cartDrawerOpennewVal) => {
      if (cartDrawerOpennewVal) {
        $analytics.cartViewed(bundle.value);
      }
      toggleScroll(cartDrawerOpennewVal);
      toggleDriftChat(cartDrawerOpennewVal);
    });

    return {
      cartActive,
      cartDrawerOpen,
      cart,
      isEquipInCart,
      bundle,
      getTabIndex,
      getJustifyContent,
      isCartEmpty,
      getCtaText,
      closeDrawer,
      onConfirm,
      isShopifyOn,
      isInCheckout,
      isTest14,
    };
  },
});
